const state = {
  statuses:            {
    new:       {
      id:    1,
      name:  "Новая",
      color: "rgb(var(--app-primary))",
      key:   "new",
    },
    accepted:  {
      id:    2,
      name:  "Не назначена",
      color: "rgb(var(--app-danger))",
      key:   "accepted",
    },
    assigned:  {
      id:    3,
      name:  "Назначена",
      color: "rgb(var(--app-warning))",
      key:   "assigned",
    },
    'in-work': {
      id:    4,
      name:  "В работе",
      color: "#EAC464",
      key:   "in-work",
    },
    cancel:    {
      id:    5,
      name:  "Отклонена",
      color: "#cccace",
      key:   "cancel",
    },
    done:      {
      id:    6,
      name:  "Выполнена",
      color: "rgb(var(--app-success))",
      key:   "done",
    },
  },
  priorities:          {
    lowest:  {
      id:    0,
      name:  'Низший',
      icon:  'ChevronsDownIcon',
      color: 'rgb(105, 162, 96)',
    },
    low:     {
      id:    1,
      name:  'Низкий',
      icon:  'ChevronDownIcon',
      color: 'rgb(71, 132, 64)',
    },
    medium:  {
      id:    2,
      name:  'Средний',
      icon:  'MinusIcon',
      color: 'rgb(220, 129, 60)',
    },
    high:    {
      id:    3,
      name:  'Высокий',
      icon:  'ChevronUpIcon',
      color: 'rgb(217, 81, 76)',
    },
    highest: {
      id:    4,
      name:  'Наивысший',
      icon:  'ChevronsUpIcon',
      color: 'rgb(189, 39, 26)',
    },
  },
  type:                {
    inner: {
      id:   0,
      name: 'Внутренняя',
    },
    outer: {
      id:   1,
      name: 'Внешняя',
    },
  },
  newCategories:       {
    bookkeeping:    {
      id:        6,
      icon:      'MoneyIcon',
      name:      'Бухгалтерия',
      nameShort: 'Бухгалтерия',
      color:     'rgba(var(--app-success), 1)',
    },
    administrative: {
      id:        7,
      icon:      'SettingsIcon',
      name:      'Административные вопросы',
      nameShort: 'Администр.',
      color:     'rgba(var(--app-info), 1)',
    },
    support:        {
      id:        8,
      icon:      'SupportIcon',
      name:      'Техническая поддержка',
      nameShort: 'Техподдержка',
      color:     'rgba(var(--app-primary), 1)',
    },
    emergency:      {
      id:         9,
      icon:       'CallIcon',
      name:       'Аварийные заявки',
      nameShort:  'Аварийные',
      color:      'rgba(var(--app-danger), 1)',
      showClient: false,
    },
  },
  categories:          {
    electricity: {
      id:    1,
      icon:  'ElectricityIcon',
      name:  'Электричество',
      color: 'rgba(var(--app-warning), 1)',
    },
    sewerage:    {
      id:    2,
      icon:  'SewerageIcon',
      name:  'Канализация',
      color: '#1e1e1e',
    },
    water:       {
      id:    3,
      icon:  'WaterIcon',
      name:  'Вода',
      color: 'rgba(var(--app-info), 1)',
    },
    other:       {
      id:    5,
      icon:  'SettingsIcon',
      name:  'Прочее',
      color: 'rgba(var(--app-primary), 1)',
    },
  },
  unreadMessages:      {},
  unreadMessagesTotal: 0,
  // unreadByCategories:  {},
  unreadByStatuses:    {},
  sortTypes:           [
    {
      title: 'Имя',
      key:   'name',
    },
    {
      title: 'Приоритет',
      key:   'priority',
    },
    {
      title: 'Статус',
      key:   'status_id',
    },
  ],
};

export default state;
